<template>
  <Layout :title="page.title" />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { QuestionnaireView } from '@/models/onboarding'
import type { BookValidation20710Page } from '@/models/onboarding.types'

import Layout from '../Layout.vue'

const props = defineProps<{
  view: QuestionnaireView
}>()

const page = computed(() => props.view.currentPage as BookValidation20710Page)
</script>
